// import node module libraries
import React, { Fragment, useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { Button, Col, Row, Tab, Card, Nav} from 'react-bootstrap';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

// Import authentication components
import useAuthHeader from 'react-auth-kit/hooks/useAuthHeader';

// import notification component
import Notification, { handleShowNotification } from 'components/elements/notification/Notification';

// import sub custom components
import TACSettingsTable from './TACSettingsTable';
import OffCanvasCreateTAC from './OffcanvasCreateTAC';

const AllTACSettings = ({ activeKey }) => { // activeKey als Prop erhalten
	const { t } = useTranslation(); // useTranslation-Hook
	const [notification, setNotification] = useState({ variant: '', title: '', message: '' });
	const [isLoadingButtonCreateTAC, setIsLoadingButtonCreateTAC] = useState(null); // State for loading spinner

	const [page, setPage] = useState(1);
	const [TACdata, setTACData] = useState([]);
	const [isLoadingTable, setIsLoadingTable] = useState(true); // State for loading table

	// Create TAC
	const [showCreateTACOffcanvas, setShowCreateTACOffcanvas] = useState(false);
	const handleShowCreateTAC = () => setShowCreateTACOffcanvas(true);
	const handleCloseCreateTAC = () => setShowCreateTACOffcanvas(false);
	const [createdNewTAC, setCreatedNewTAC] = useState(false); // State to trigger re-fetch

	// fetch data from api
	const authHeader = useAuthHeader();
	const options = {
		params: {

		},
		headers: {
			Authorization: authHeader,
			Accept: 'application/json'
		}
	};

	// Get data from API

	const getData = async () => {
		setIsLoadingTable(true);

		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.get(`${baseURL}/public/terms-and-conditions`, options)
			.then(response => {
				setTACData({ data: response.data.data });
				setIsLoadingTable(false);
			})
			.catch((error) => {
				const errorMessage = error.response?.data?.message
					? error.message + '. ' + error.response.data.message
					: error.message;
				handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');
				setIsLoadingTable(false);
			});
	}

	useEffect(() => {
		// Check if the current tab is active before making the API call
		if (activeKey === 'terms-and-conditions') {
			getData();
		}
	}, [activeKey, createdNewTAC]); // Run effect when activeKey, filterBy, or page changes

	// Create TAC

	const handleCreateTAC = async (e) => {
		e.preventDefault();
		setIsLoadingButtonCreateTAC(true);

		const data = {
			agb_version: e.target.version.value,
			agb_date: e.target.date.value,
			agb_text: e.target.content.value
		};

		// Dynamische URL basierend auf der Umgebung
		const baseURL = process.env.REACT_APP_ENV === 'development'
			? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
			: `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;

		await axios.post(`${baseURL}/public/terms-and-conditions`, data, options)
			.then(response => {
				// Trigger a re-fetch of the data
				setCreatedNewTAC(true);
				// Close the offcanvas
				setShowCreateTACOffcanvas(false);
				setIsLoadingButtonCreateTAC(false);
				// Reset the form fields
				e.target.reset();
				// Show success notification
				handleShowNotification(setNotification, 'success', 'Erfolgreich', 'Deine Daten wurden erfolgreich gespeichert');
			})
			.catch((error) => {
				setShowCreateTACOffcanvas(false);
				setIsLoadingButtonCreateTAC(false);
				const errorMessage = error.response?.data?.message ? error.message + '. ' + error.response.data.message : error.message;
				handleShowNotification(setNotification, 'danger', 'Fehler', errorMessage + '. Bitte versuche es erneut oder kontaktiere den HelpDesk.');
			});
	};

	return (
		<Fragment>
			{notification.show && (
				<Notification variant={notification.variant} title={notification.title} message={notification.message} show={notification.show} setNotification={setNotification} />
			)}
			<Row>
				{/* Create TAC */}
				<Col xl={{ offset: 1, span: 10 }} lg={{ offset: 1, span: 10 }} md={12}>
					<div className="border-bottom pb-4 mb-4 d-flex align-items-center justify-content-end">
						<Button variant="secondary" className="me-2" onClick={handleShowCreateTAC}>
							{t('Create new TAC')}
						</Button>
					</div>
				</Col>
			</Row>
			<Row>
				<Col xl={{ offset: 1, span: 10 }} lg={{ offset: 1, span: 10 }} md={12}>
					<Tab.Container defaultActiveKey="all">
						<Card>
							<Card.Header className="border-bottom-0 p-0 bg-white">
								<Nav className="nav-lb-tab">
									<Nav.Item>
										<Nav.Link eventKey="all" className="mb-sm-3 mb-md-0">
											{t('All TACs')}
										</Nav.Link>
									</Nav.Item>
								</Nav>
							</Card.Header>
							<Card.Body className="p-0">
								<Tab.Content>
									<Tab.Pane eventKey="all" className="pb-4">
										<TACSettingsTable activeKey={activeKey} TACdata={TACdata} isLoadingTable={isLoadingTable} filterBy="" />
									</Tab.Pane>
								</Tab.Content>
							</Card.Body>
						</Card>
					</Tab.Container>
				</Col>
			</Row>
			{/* Create TAC Offcanvas */}
			<OffCanvasCreateTAC
				show={showCreateTACOffcanvas}
				onHide={handleCloseCreateTAC}
				onSubmit={handleCreateTAC}
				isLoadingButton={isLoadingButtonCreateTAC}
			/>
		</Fragment>
	);
};

export default AllTACSettings;
